import { publicDataFetch } from "../api";

const TABLE_NAME = "hri_submissions";

export async function saveSubmission(payload) {
  try {
    const formattedPayload = {
      ...payload,
      created_at: new Date().toISOString().slice(0, 19).replace('T', ' ')
    };

    const res = await publicDataFetch(`create/${TABLE_NAME}`, {
      method: "POST",
      body: JSON.stringify(formattedPayload),
    });

    if (res.status === "error") {
      console.error("NCB Save Error:", res.error);
      return { ok: false, error: res.error };
    }
    return { ok: true, data: res.data };
  } catch (e) {
    console.error("NCB Exception:", e);
    return { ok: false, error: String(e) };
  }
}

export async function fetchAllSubmissions() {
  try {
    const res = await publicDataFetch(`read/${TABLE_NAME}?limit=100&sort=created_at&order=desc`);
    if (res.status === "error") {
      return { ok: false, error: res.error };
    }
    return { ok: true, data: res.data ?? [] };
  } catch (e) {
    return { ok: false, error: String(e) };
  }
}